var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lang-cnt" }, [
    _c("a", { attrs: { href: _vm.opensaludLink, target: "_blank" } }, [
      _vm._v("OPENSALUD")
    ]),
    _vm._v(" "),
    !_vm.inMx
      ? _c("a", { attrs: { href: _vm.opensaludMxLink } }, [
          _vm._v("OPENSALUD MEXICO")
        ])
      : _c("a", { attrs: { href: _vm.opensaludEsLink } }, [
          _vm._v("OPENSALUD ESPAÑA")
        ]),
    _vm._v(" "),
    !_vm.inMx
      ? _c("a", { attrs: { href: "https://menttum.com", target: "_blank" } }, [
          _vm._v("MENTTUM")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "a",
      { attrs: { href: _vm.$helpers.get360AppUrl(), target: "_blank" } },
      [_vm._v("OPENSALUD360")]
    ),
    _vm._v(" "),
    !_vm.inMx
      ? _c(
          "a",
          {
            attrs: {
              href: _vm.$helpers.getV2AppUrl("opensalud4all"),
              target: "_blank"
            }
          },
          [_vm._v("OPENSALUD4ALL")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c3bfe90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3bfe90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/GroupLinks.vue
// module id = 2514
// module chunks = 16 17 18 19 20 21 22 23 30 31 40